import { CommonModule } from "@angular/common";
import { Component, HostListener, Output, EventEmitter } from "@angular/core";
import { RouterModule } from "@angular/router";
import { FooterComponent } from "../../footer/footer.component";
import { HeaderComponent } from "../../header/header.component";
import { NavService } from "../../../services/nav.service";
import { LayoutService } from "../../../services/layout.service";

@Component({
  selector: "app-content",
  standalone: true,
  imports: [HeaderComponent, FooterComponent, CommonModule, RouterModule],
  templateUrl: "./content.component.html",
  styleUrls: ["./content.component.scss"],
})
export class ContentComponent {
  @Output() customerAdded = new EventEmitter<any>();

  public innerWidth: number;
  public footerFix = false;
  public footerLight = false;
  public footerDark: boolean = false;

  constructor(public navService: NavService, public layout: LayoutService) {}

  ngOnInit() {
    this.innerWidth = window.innerWidth;
  }

  @HostListener("window:resize", ["$event"])
  onResize(event: any) {
    if (window.innerWidth < 1200) {
      this.layout.config.settings.sidebar_type = "page-wrapper compact-wrapper";
    }
  }

  get layoutClass() {
    return this.layout.config.settings.sidebar_type + "";
  }

  ngDoCheck() {
    if (window.location.pathname == "/page-layout/footer-dark") {
      this.footerDark = true;
      this.footerLight = false;
      this.footerFix = false;
    } else if (window.location.pathname == "/page-layout/footer-light") {
      this.footerLight = true;
      this.footerDark = false;
      this.footerFix = false;
    } else if (window.location.pathname == "/page-layout/footer-fixed") {
      this.footerFix = true;
      this.footerLight = false;
      this.footerDark = false;
    }
  }

  ngOnDestroy() {
    this.footerDark = false;
  }

  onCustomerAdded(customer: any) {
    this.customerAdded.emit(customer);
  }
}
